import React from "react";
import overrideClasses from "../../../utils/overrideClasses";
import IntlMessages from "../../../utils/messages";

type HeadProps = {
  headArray: (string | JSX.Element)[];
  headBgColor?: string;
  headTextColor?: string;
};

const Head: React.FC<HeadProps> = ({
  headArray,
  headBgColor = "bg-gray-100",
  headTextColor,
}) => {
  return (
    <thead>
      <tr className={headBgColor}>
        {headArray.map((headTitle, index) => {
          const isFirst = index === 0;
          const isLast = index === headArray.length - 1;
          const isActions = headTitle === "general.actions";

          const thClasses = overrideClasses(
            "px-8 h-10 text-14px leading-5 text-ground-gray-100 uppercase border-b border-t border-neutral-100",
            headTextColor,
            isFirst ? "text-left rounded-tl-lg border-l" : "text-center",
            isLast ? "rounded-tr-lg border-r" : "",
            isActions ? "w-0" : ""
          );

          return (
            <th
              key={
                typeof headTitle === "string"
                  ? `${headTitle}-${index}`
                  : `head-${index}`
              }
              className={thClasses}
            >
              {typeof headTitle === "string" ? (
                <IntlMessages id={headTitle} />
              ) : (
                headTitle
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default Head;
